import {WorkflowTemplateContainer} from './components/workflow-template-container';

export default {
    component: WorkflowTemplateContainer
};
